const ISRACARD_PRODUCTION_BASE_HOST = 'time-off.co.il';
const ISRACARD_STAGING_BASE_HOST = 'takeoff.arbitrip.dev';

function normalizeHostname(hostname) {
    return typeof hostname === 'string' ? hostname.trim().toLowerCase() : '';
}

function resolveHostname(hostname) {
    if (typeof hostname === 'string') {
        return normalizeHostname(hostname);
    }

    if (typeof window === 'object' && typeof window.location?.hostname === 'string') {
        return normalizeHostname(window.location.hostname);
    }

    return '';
}

function isIsracardProductionHostname(hostname) {
    const normalizedHostname = resolveHostname(hostname);

    if (!normalizedHostname) {
        return false;
    }

    return normalizedHostname.includes(ISRACARD_PRODUCTION_BASE_HOST);
}

function getIsracardBaseHost(hostname) {
    return isIsracardProductionHostname(hostname) ? ISRACARD_PRODUCTION_BASE_HOST : ISRACARD_STAGING_BASE_HOST;
}

function getIsracardBaseUrl(hostname) {
    return `https://${getIsracardBaseHost(hostname)}`;
}

function getIsracardFlightsUrl(hostname) {
    return getIsracardBaseUrl(hostname);
}

module.exports = {
    getIsracardBaseUrl,
    getIsracardFlightsUrl,
};
